import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { getDefaultCompanyId } from 'utils/helpers';

interface typesOfwalletActivity {
    walletActivityData: any;
    loading: boolean;
    error: string | null;
}
const initialState: typesOfwalletActivity = {
    walletActivityData: [],
    loading: false,
    error: null,
};

export const fetchWalletActivity = createAsyncThunkWrapper<any, any>(
    'walletActivity/fetchWalletActivity',
    async (filter: any, { getState }) => {
        const { dayFrom, dayTo, pageSize, offset = 0 } = filter || {};
        const state: any = getState();
        const defaultCompanyId = getDefaultCompanyId(state);
        const response: any = await client.post(
            '/merchant/getHistory',
            {
                dayFrom,
                dayTo,
                companyId: defaultCompanyId,
                frontEndDate: true,
            },
            { pageSize, offset }
        );
        return response.trxHistories;
    }
);

const walletActivitySlice = createSlice({
    name: 'walletActivitySlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchWalletActivity.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchWalletActivity.fulfilled, (state, action) => {
            state.loading = false;
            if (!action.payload) return;
            state.walletActivityData = action.payload || [];
        });
        builder.addCase(fetchWalletActivity.rejected, (state) => {
            state.loading = false;
        });
    },
});
export default walletActivitySlice.reducer;
